import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accentColor", "children", "onClick"];
import styled from 'styled-components';
import { getCanReadTextOnce } from 'visitor-ui-component-library/utils/colors';
import { OBSIDIAN, NEUTRAL_800, NEUTRAL_900, WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { promptButtonBaseStyles } from '../shared/components/BasePromptButton';
import { jsx as _jsx } from "react/jsx-runtime";
const QuickReplyButtonStyled = styled.button.withConfig({
  displayName: "QuickReplyButton__QuickReplyButtonStyled"
})(["", " background:", ";color:", ";border:1px solid ", ";cursor:pointer;&:hover:not(:disabled){color:", ";border-color:", ";}&:disabled{opacity:0.6;cursor:not-allowed;}"], promptButtonBaseStyles, WHITE, OBSIDIAN, NEUTRAL_800, ({
  $accentColor
}) => $accentColor || NEUTRAL_900, ({
  $accentColor
}) => $accentColor || NEUTRAL_900);
const QuickReplyButton = _ref => {
  let {
      accentColor,
      children,
      onClick
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const isTextReadable = getCanReadTextOnce(accentColor);
  const accessibleAccentColor = isTextReadable ? accentColor : OBSIDIAN;
  return /*#__PURE__*/_jsx(QuickReplyButtonStyled, Object.assign({
    $accentColor: accessibleAccentColor,
    onClick: onClick
  }, props, {
    children: children
  }));
};
QuickReplyButton.displayName = 'QuickReplyButton';
export default QuickReplyButton;